"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Organisation = void 0;
var create_entity_1 = require("../../utils/create-entity");
var create_entity_2 = require("../../utils/create-entity");
var current_user_can_1 = require("../../utils/current-user-can");
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var components_1 = require("../../components");
var is_image_1 = require("../../utils/is-image");
var organisation_cell_1 = require("../../components/entities/organisation-cell");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
var graphql_1 = require("../../utils/graphql");
var typeIs = function (key) {
  return function (context) {
    // we need a map of record IDs to quickly check whether certain fields are available
    var _a = context.data,
      data = _a === void 0 ? {} : _a,
      _b = context.fieldState,
      fieldState = _b === void 0 ? {} : _b;
    var _c = data.organisationTypes,
      organisationTypes = _c === void 0 ? [] : _c;
    var typesBySlug = (0, lodash_1.keyBy)(organisationTypes, 'slug');
    var TYPE_IDS = {
      citizen: (0, lodash_1.get)(typesBySlug, "['citizen'].id"),
      care: (0, lodash_1.get)(typesBySlug, "['care-provider'].id"),
      startup: (0, lodash_1.get)(typesBySlug, "['startup'].id"),
      corporation: (0, lodash_1.get)(typesBySlug, "['corporation'].id"),
      researcher: (0, lodash_1.get)(typesBySlug, "['researcher-or-think-tank'].id"),
      investor: (0, lodash_1.get)(typesBySlug, "['investor-or-foundation'].id"),
      association: (0, lodash_1.get)(typesBySlug, "['association-or-network'].id")
    };
    return fieldState['type'] === TYPE_IDS[key];
  };
};
exports.Organisation = {
  name: 'Organisation',
  isPublic: true,
  groupName: 'Community',
  autoRoutes: ['list', 'details', 'create', 'update'],
  imageStyle: 'logo',
  usePublishStatus: true,
  useDuplicateCheck: true,
  useConversation: true,
  useFollowers: true,
  useSites: true,
  includeInSearch: true,
  useVisibility: true,
  useModerators: true,
  useConnections: true,
  useSpaces: true,
  useSlices: true,
  usePermissions: true,
  canEmbed: true,
  // useNetwork: true,
  useMembership: true,
  platformActivity: {
    tab: 'own'
  },
  select: {
    transform: function (entity, context) {
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        singleValueImage: entity.logo && (0, is_image_1.isImage)(entity.logo) && entity.logo.url
      });
    },
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      logo {\n        id url\n        thumbnails {\n          small { id url }\n        }\n      }\n    "], ["\n      logo {\n        id url\n        thumbnails {\n          small { id url }\n        }\n      }\n    "])))
  },
  /* -------------- COMPONENTS -------------- */
  components: {
    card: components_1.OrganisationCard,
    details: components_1.OrganisationDetailsLayout,
    cell: organisation_cell_1.OrganisationCell,
    image: components_1.OrganisationImage
  },
  banner: {
    showDescription: false,
    alignItems: 'center',
    imageSize: 'medium'
  },
  filters: {
    fields: {
      country: {
        entityTypeName: 'Economy'
      },
      state: {
        entityTypeName: 'State'
      },
      challenges: {
        entityTypeName: 'Challenge'
      },
      location: {
        entityTypeName: 'Location'
      },
      keyIssues: {
        entityTypeName: 'KeyIssue'
      },
      type: {
        entityTypeName: 'OrganisationType'
      }
    }
  },
  /* -------------- LIST -------------- */
  list: {
    hasFilters: true,
    applyVisibilityState: true,
    baseState: {
      filter: {
        isPublished: {
          is: true
        }
      },
      orderBy: {
        fieldName: "name"
      },
      limit: create_entity_2.ITEMS_PER_PAGE,
      skip: 0
    },
    banner: {
      content: 'Explore leading {{ORGANISATIONS}} in the space'
    },
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      isMember\n      feedEntries { id }\n      positions { id }\n      challenge { id slug name }\n      description { id text(truncate: { words: 50 }) }\n      location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      industries { id slug name }\n      type { id slug name }\n      logo { id url thumbnails { id full { id url width height } } }\n    "], ["\n      isMember\n      feedEntries { id }\n      positions { id }\n      challenge { id slug name }\n      description { id text(truncate: { words: 50 }) }\n      location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      industries { id slug name }\n      type { id slug name }\n      logo { id url thumbnails { id full { id url width height } } }\n    "])))
  },
  /* -------------- DETAILS --------------- */
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      id\n      sid\n      name\n      slug\n      organisationStatus { id name slug }\n      allowsPersonalInfo\n      description { id text }\n      primaryContact { ...EntityValueFields agreesToSharePersonalInfo phone email }\n      featureVideoUrl\n      url\n      facebook\n      twitter\n      linkedin\n      youtube\n      pinterest\n      instagram\n      positions { id }\n      feedEntries { id }\n      type { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n      chapterRoles { chapter { ...EntityValueFields } role { ...EntityValueFields } }\n      teamRoles { team { ...EntityValueFields } role { ...EntityValueFields } }\n      sessionRoles { session { ...EntityValueFields } role { ...EntityValueFields } }\n      eventRoles { event { ...EntityValueFields } role { ...EntityValueFields } }\n      productRoles { product { ...EntityValueFields } role { ...EntityValueFields } }\n      posts { ...EntityValueFields }\n      positions { id primary position person { ...EntityValueFields } }\n      businessModel { id name slug }\n      challenges { id name slug openGraph { id title image { id url } }  }\n      industries { id name slug }\n      logo { id url thumbnails { id full { id url width height } } }\n      location { ...EntityValueFields state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n    "], ["\n      id\n      sid\n      name\n      slug\n      organisationStatus { id name slug }\n      allowsPersonalInfo\n      description { id text }\n      primaryContact { ...EntityValueFields agreesToSharePersonalInfo phone email }\n      featureVideoUrl\n      url\n      facebook\n      twitter\n      linkedin\n      youtube\n      pinterest\n      instagram\n      positions { id }\n      feedEntries { id }\n      type { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n      chapterRoles { chapter { ...EntityValueFields } role { ...EntityValueFields } }\n      teamRoles { team { ...EntityValueFields } role { ...EntityValueFields } }\n      sessionRoles { session { ...EntityValueFields } role { ...EntityValueFields } }\n      eventRoles { event { ...EntityValueFields } role { ...EntityValueFields } }\n      productRoles { product { ...EntityValueFields } role { ...EntityValueFields } }\n      posts { ...EntityValueFields }\n      positions { id primary position person { ...EntityValueFields } }\n      businessModel { id name slug }\n      challenges { id name slug openGraph { id title image { id url } }  }\n      industries { id name slug }\n      logo { id url thumbnails { id full { id url width height } } }\n      location { ...EntityValueFields state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n    "])))
  },
  /* -------------- FORM -------------- */
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'places'
    }, {
      label: 'Web & Social',
      name: 'web-social'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'related',
      label: 'Related Orgs'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      type: {
        type: 'linked',
        entityTypeName: 'OrganisationType',
        description: 'What type of {{ORGANISATION}} is this?'
      },
      corporationSize: {
        type: 'linked',
        entityTypeName: "CorporationSize",
        isVisible: typeIs('corporation'),
        description: 'How large is this {{ORGANISATION}}?'
      },
      primaryContact: {
        type: 'linked',
        label: 'Primary Contact',
        entityTypeName: 'Person'
      },
      logo: {
        type: 'image',
        fieldOptions: {
          useCropping: true
        },
        description: 'Upload or search for the logo for this {{ORGANISATION}}'
      },
      logoInverted: {
        label: "Logo (Inverted)",
        recommended: false,
        type: 'image',
        isInverted: true,
        fieldOptions: {
          useCropping: true
        },
        description: 'Provide a logo for this {{ORGANISATION}} which is appropriate for dark backgrounds. Ideally, this should be a largely white logo with a transparent background. Note that GIF images will not work well, this must be PNG or WEBP image with a proper alpha channel.'
      },
      logoSubtle: {
        label: "Logo (Subtle)",
        recommended: false,
        type: 'image',
        isInverted: true,
        fieldOptions: {
          useCropping: true
        },
        description: 'Provide a more subtle logo for this {{ORGANISATION}} which will be shown in the Powered By area of website footers, to not draw attention away from the main organisation\'s logo. Note that GIF images will not work well, this must be PNG or WEBP image with a proper alpha channel.'
      },
      logoInvertedSubtle: {
        label: "Logo (Inverted, Subtle)",
        recommended: false,
        type: 'image',
        isInverted: true,
        fieldOptions: {
          useCropping: true
        },
        description: 'Provide a more subtle logo for this {{ORGANISATION}} which will be shown in the Powered By area of website footers, for dark backgrounds.'
      },
      objectives: {
        type: 'linkedMultiple',
        entityTypeName: 'Objective',
        fieldSet: 'overview'
      },
      description: {
        type: 'description'
      },
      locations: {
        type: 'linkedMultiple',
        focus: true,
        entityTypeName: 'Location',
        fieldSet: 'places',
        description: 'Where is this {{ORGANISATION}} located?'
      },
      states: {
        type: 'linkedMultiple',
        entityTypeName: 'State',
        description: 'Alternatively, are they located in any specifc or other {{STATES}}?',
        fieldSet: 'places'
      },
      regions: {
        type: 'linkedMultiple',
        entityTypeName: 'Region',
        description: 'Alternatively, are they located in any specifc or other {{REGIONS}}?',
        fieldSet: 'places'
      },
      countries: {
        type: 'linkedMultiple',
        entityTypeName: 'Economy',
        description: 'Which {{ECONOMY}} is this organisation located in?',
        fieldSet: 'places'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      industries: {
        type: 'linkedMultiple',
        entityTypeName: 'Industry',
        fieldSet: 'taxonomies'
      },
      sdgs: {
        type: 'linkedMultiple',
        entityTypeName: 'Sdg',
        fieldSet: 'taxonomies'
      },
      url: {
        type: 'url',
        fieldSet: 'web-social',
        description: 'Provide the web address for the website of this {{ORGANISATION}}'
      },
      blogUrl: {
        type: 'url',
        placeholder: 'https://domain.com',
        fieldSet: 'web-social',
        description: 'Enter the web address for the blog of this {{ORGANISATION}}.'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        fieldSet: 'web-social'
      },
      deckUrl: {
        type: 'url',
        placeholder: 'https://domain.com',
        fieldSet: 'web-social',
        label: 'Slide Deck URL',
        description: 'Enter the web address of a slide deck for this {{ORGANISATION}}, e.g. the address of a Powerpoint presentation hosted online.'
      },
      twitter: {
        type: 'url',
        label: "X",
        placeholder: 'https://x.com/handle',
        fieldSet: 'web-social',
        description: 'What is the public URL of the X (formerly Twitter) profile of this {{ORGANISATION}}?'
      },
      threads: {
        type: 'url',
        placeholder: 'https://www.threads.net/@handle',
        fieldSet: 'social',
        description: 'What is the URL of the Threads profile of this {{ORGANISATION}}?'
      },
      facebook: {
        type: 'url',
        placeholder: 'https://www.facebook.com/organisation',
        fieldSet: 'web-social',
        description: 'What is the public URL of the Facebook profile of this {{ORGANISATION}}?'
      },
      linkedin: {
        type: 'url',
        placeholder: 'https://www.linkedin.com/company/012345678',
        fieldSet: 'web-social',
        description: 'What is the public URL of the LinkedIn profile of this {{ORGANISATION}}?'
      },
      youtube: {
        type: 'url',
        placeholder: 'https://www.youtube.com/user/organisation',
        fieldSet: 'web-social',
        description: 'What is the public URL of the YouTube Channel of this {{ORGANISATION}}?'
      },
      pinterest: {
        type: 'url',
        placeholder: 'https://www.pinterest.com/user',
        fieldSet: 'web-social',
        description: 'What is the public URL of the Pinterest account for this {{ORGANISATION}}?'
      },
      instagram: {
        type: 'url',
        placeholder: 'https://www.instagram.com/user',
        fieldSet: 'web-social',
        description: 'What is the public URL of the Instagram account for this {{ORGANISATION}}?'
      },
      featureVideoUrl: {
        type: 'url',
        placeholder: 'https://youtube.com/',
        fieldSet: 'web-social',
        description: 'Provide a web address for a video which introduces this {{ORGANISATION}}, e.g. a video on YouTube, Vimeo, or similar'
      },
      angelListUrl: {
        type: 'url',
        label: "Angel List",
        placeholder: 'https://angel.co/company/name',
        fieldSet: 'web-social',
        description: 'What is the public URL of the Angel List profile for this {{ORGANISATION}}?'
      },
      crunchbaseUrl: {
        type: 'url',
        label: "Crunchbase",
        placeholder: 'https://www.crunchbase.com/organization/name',
        fieldSet: 'web-social',
        description: 'What is the public URL of the Crunchbase profile for this {{ORGANISATION}}?'
      },
      // ------- People & Teams ------->
      partnerOrganisations: {
        type: 'linkedMultiple',
        label: 'Partner {{ORGANISATIONS}}',
        canCreate: function () {
          return false;
        },
        entityTypeName: 'Organisation',
        fieldSet: 'related',
        description: 'Are there any other {{ORGANISATIONS}} this {{ORGANISATION}} already works with?'
      },
      desiredPartnerOrganisations: {
        type: 'linkedMultiple',
        label: 'Desired Partner {{ORGANISATIONS}}',
        canCreate: function () {
          return false;
        },
        entityTypeName: 'Organisation',
        fieldSet: 'related',
        description: 'Are there any {{ORGANISATIONS}} this {{ORGANISATION}} would like to work with?'
      },
      organisationStatus: {
        type: 'linked',
        fieldSet: 'admin',
        entityTypeName: 'OrganisationStatus',
        isVisible: function () {
          return (0, current_user_can_1.currentUserCan)('write:any');
        },
        description: 'What is the membership status of this {{ORGANISATION}}?'
      }
    }),
    reverseFields: {
      // need to query the entity which is selected via the source entity select loaded, and pull a standard update query with sourceFieldName included. We can assume sourceFieldName is a linked entity field.
      positions: {
        type: 'linkedMultiple',
        label: 'Add {{ORGANISATION_POSITION}}',
        entityTypeName: 'OrganisationPosition',
        source: 'organisation',
        reverseEntityTypeName: 'Person',
        reverseEntityFieldName: 'positions'
      }
    },
    /* TODO - it would be great to have a global dictionary for these kinds of queries (implemented with context/use hook) but this will be better handled when Apollo Client 3 is included, because we need a reliable way to expire cache on such a dictionary */
    query: (0, client_1.gql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      {\n        organisationTypes: allOrganisationTypes { id name slug }\n      }\n    "], ["\n      {\n        organisationTypes: allOrganisationTypes { id name slug }\n      }\n    "])))
  },
  /* -------------- CREATE -------------- */
  create: {
    label: 'Add %s'
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      description { text }\n      type { name }\n      primaryContact { name email }\n      url\n      location { name }\n      country { name }\n      logo { url }\n      facebook\n      twitter\n      linkedin\n      youtube\n      pinterest\n      instagram\n      slug\n    "], ["\n      description { text }\n      type { name }\n      primaryContact { name email }\n      url\n      location { name }\n      country { name }\n      logo { url }\n      facebook\n      twitter\n      linkedin\n      youtube\n      pinterest\n      instagram\n      slug\n    "])))
  },
  /* -------------- UPDATE -------------- */
  update: {
    queryFields: (0, graphql_1.graphql)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      visibility { id name slug }\n      description { id text }\n      url\n      twitter\n      facebook\n      linkedin\n      youtube\n      pinterest\n      instagram\n      sites { id name slug openGraph { description { id text } id image { id url } } }\n\n      logo { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      featureVideoUrl\n      blogUrl\n      deckUrl\n\n      videos { id name slug openGraph { id title image { id url } } }\n\n      organisationStatus { id name slug }\n      type { id name slug }\n\n      challenges { id name slug openGraph { id title image { id url } } }\n\n      partnerOrganisations { id name slug }\n      desiredPartnerOrganisations { id name slug }\n\n      locations { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      states { id name slug abbr }\n      countries { id slug name _optionLabel iso shorthand openGraph { id image { id url } } }\n\n      positions { \n        id\n        name\n        slug\n        position\n        primary\n        positions {\n          id\n          name\n          slug\n          shorthand\n        }\n        organisation {\n          id\n          name\n          logo {\n            id url thumbnails { id full { id url width height } }\n          }\n          location {\n            id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand }\n          }\n        }\n        person {\n          id\n          name\n          slug\n          photo {\n            id\n            url\n          }\n          location {\n            id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand }\n          }\n        }\n      }\n      teamRoles { \n        id name role { id slug name }\n        team { id name summary { id text } }\n        organisation { id name logo { id url thumbnails { id full { id url width height } } }\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n      }\n      chapterRoles { \n        id\n        name\n        role {\n          id\n          slug\n          name\n        }\n        chapter {\n          id\n          name\n        }\n        organisation {\n          id\n          name\n          logo {\n            id url thumbnails { id full { id url width height } }\n          }\n          location {\n            id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand }\n          }\n        }\n      }\n\n      industries { id name slug }\n      corporationSize { id name slug }\n      businessModel { id name slug }\n\n      sdgs { id name number slug }\n      keyIssues { id name slug }\n      permissions { id name slug permissionTypes { id name slug } grantedPerson { id name slug organisation { id name } photo { id url } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } } }\n    "], ["\n      visibility { id name slug }\n      description { id text }\n      url\n      twitter\n      facebook\n      linkedin\n      youtube\n      pinterest\n      instagram\n      sites { id name slug openGraph { description { id text } id image { id url } } }\n\n      logo { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      featureVideoUrl\n      blogUrl\n      deckUrl\n\n      videos { id name slug openGraph { id title image { id url } } }\n\n      organisationStatus { id name slug }\n      type { id name slug }\n\n      challenges { id name slug openGraph { id title image { id url } } }\n\n      partnerOrganisations { id name slug }\n      desiredPartnerOrganisations { id name slug }\n\n      locations { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      states { id name slug abbr }\n      countries { id slug name _optionLabel iso shorthand openGraph { id image { id url } } }\n\n      positions { \n        id\n        name\n        slug\n        position\n        primary\n        positions {\n          id\n          name\n          slug\n          shorthand\n        }\n        organisation {\n          id\n          name\n          logo {\n            id url thumbnails { id full { id url width height } }\n          }\n          location {\n            id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand }\n          }\n        }\n        person {\n          id\n          name\n          slug\n          photo {\n            id\n            url\n          }\n          location {\n            id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand }\n          }\n        }\n      }\n      teamRoles { \n        id name role { id slug name }\n        team { id name summary { id text } }\n        organisation { id name logo { id url thumbnails { id full { id url width height } } }\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n      }\n      chapterRoles { \n        id\n        name\n        role {\n          id\n          slug\n          name\n        }\n        chapter {\n          id\n          name\n        }\n        organisation {\n          id\n          name\n          logo {\n            id url thumbnails { id full { id url width height } }\n          }\n          location {\n            id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand }\n          }\n        }\n      }\n\n      industries { id name slug }\n      corporationSize { id name slug }\n      businessModel { id name slug }\n\n      sdgs { id name number slug }\n      keyIssues { id name slug }\n      permissions { id name slug permissionTypes { id name slug } grantedPerson { id name slug organisation { id name } photo { id url } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } } }\n    "])))
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;